var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emoji-message",class:{response: _vm.isReply}},[_c('vue-reaction-emoji',{attrs:{"reaction":_vm.reaction,"is-active":_vm.isActive,"is-disabled":_vm.isDisabled}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }